/**
 * BusinessProcess CRUD
 */

import type { BusinessProcess } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateBusinessProcessInput {
  name: string;
  description?: string;
  processType: string;
  processTier: string;
  processOwnerId: string;
  owningBusinessUnitId: string;
  inputDescription?: string;
  outputDescription?: string;
  estimatedDuration?: string;
  volumePerPeriod?: string;
  automationLevel?: string;
  toolingDescription?: string;
  status?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateBusinessProcessInput {
  name?: string;
  description?: string;
  processType?: string;
  processTier?: string;
  processOwnerId?: string;
  owningBusinessUnitId?: string;
  inputDescription?: string;
  outputDescription?: string;
  estimatedDuration?: string;
  volumePerPeriod?: string;
  automationLevel?: string;
  toolingDescription?: string;
  status?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  BusinessProcess,
  CreateBusinessProcessInput,
  UpdateBusinessProcessInput
>('/business-processes');

export async function createBusinessProcess(
  input: CreateBusinessProcessInput
): Promise<BusinessProcess> {
  return client.create(input);
}

export async function updateBusinessProcess(
  businessProcessId: string,
  input: UpdateBusinessProcessInput
): Promise<BusinessProcess> {
  return client.update(businessProcessId, input);
}

export async function deleteBusinessProcess(
  businessProcessId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(businessProcessId, hardDelete);
}
